/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Form } from '@organisms';

import ChannelSelect from '../ChannelSelect';

const ChannelField = React.forwardRef(
  ({ queryVariables, placeholder, showAction, disabled, onChange, onSearch, value, ...props }, ref) => {
    const handleChange = (channel) => {
      // eslint-disable-next-line no-unused-expressions
      onChange?.(channel);
    };

    return (
      <>
        <Form.Item {...props}>
          <ChannelSelect
            queryVariables={queryVariables}
            placeholder={placeholder}
            onChange={handleChange}
            showAction={showAction}
            disabled={disabled}
            onSearch={onSearch}
            allowClear={false}
            value={value}
            ref={ref}
          />
        </Form.Item>
      </>
    );
  },
);

export default ChannelField;
